export default "__VITE_ASSET__uBrzitJG__"